"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMSService = void 0;
var cms_constants_1 = require("../../../../api/constants/cms.constants");
var CMSService = /** @class */ (function () {
    function CMSService() {
    }
    CMSService.getCurricula = function () {
        return fetch(CMSService.endpoint)
            .then(function (res) { return res.json(); })
            .then(function (data) { return data; });
    };
    CMSService.endpoint = "".concat(cms_constants_1.CMS_API, "/").concat(cms_constants_1.CMS_VERSION, "/").concat(cms_constants_1.CMS_COLLECTION.CURRICULA);
    return CMSService;
}());
exports.CMSService = CMSService;
